import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import AdminModalFileUpload from "./AdminModalFileUpload";
import AdminInfoModal from "./AdminInfoModal";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import DateFilter from "./DateFilter";
import moment from "jalali-moment";
import { botList, changeStatus } from "../services/adminServices";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import config from "../../../config.js";
import AdminPlanModal from "./AdminPlanModal"
import AdminCountModal from "./AdminCountModal"
const statuses = ["تایید شده", "عدم تایید", "در انتظار", "ثبت اولیه"];
const statusModal = ["تایید شده", "عدم تایید", "در انتظار"];
export default function AdminPublishTable({ onStatusCountsChange }) {
  const mapStatus = {
    accepted: "تایید شده",
    rejected: "عدم تایید",
    pending: "در انتظار",
    empty: "ثبت اولیه",
  };
  const [transactions, setTransactions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("همه");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [originalTransactions, setOriginalTransactions] = useState([]); // داده‌های اصلی تراکنش‌ها
  const BASE_URL = config.cdnUrl;
  const [isUsernameModalOpen, setIsUsernameModalOpen] = useState(false);
  const [usernameModalData, setUsernameModalData] = useState(null);
  const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);
  const [planModalData, setPlanModalData] = useState(null);
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [countModal, setCountModal] = useState({
    isOpen: false,
    type: null,
    title: "",
    count: 0,
    files: [],
    data: null,
  });

  const accessToken = useSelector((state) => state.auth.accessToken);
  useEffect(() => {
    const getInfo = async () => {
      try {
        const res = await botList(accessToken);

        if (res?.ok) {
          const bots = Array.isArray(res?.data)
            ? res.data
            : [];

          const sortedData = [...bots].sort(
            (a, b) =>
              new Date(b.createdAt) - new Date(a.createdAt)
          );

          const formattedData = sortedData.map((item) => {
            const [date, time] = item.createdAt?.split(" ") || ["", ""];

            return {
              ...item,

              status: mapStatus[item.status] || "نامشخص",

              knowledgeFiles: Array.isArray(item.knowledgeFiles)
                ? item.knowledgeFiles
                : [],

              knowledgeFileCount:
                item.knowledgeFileCount ??
                (Array.isArray(item.knowledgeFiles)
                  ? item.knowledgeFiles.length
                  : 0),

              date,
              time,
            };
          });

          setTransactions(formattedData);
          setOriginalTransactions(formattedData);
        }
      } catch (error) {
        console.log("خطا در دریافت اطلاعات:", error);
      }
    };

    getInfo();
  }, [accessToken]);
  const openModal = (row) => {
    setModalData(row);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };
  const openUsernameModal = (row) => {
    setUsernameModalData(row); // ذخیره داده‌های مربوط به username
    setIsUsernameModalOpen(true); // باز کردن مودال
  };

  const closeUsernameModal = () => {
    setIsUsernameModalOpen(false); // بستن مودال
    setUsernameModalData(null); // پاک کردن داده‌ها
  };
  const openPlanModal = (row) => {
    setPlanModalData(row); // ذخیره داده‌های مربوط به username
    setIsPlanModalOpen(true); // باز کردن مودال
  };

  const closePlanModal = () => {
    setIsPlanModalOpen(false);
    setPlanModalData(null);
  };
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const sortedTransactions = [...transactions].sort((a, b) => {
    if (sortConfig.key) {
      if (sortConfig.key === "count") {
        return sortConfig.direction === "asc"
          ? a.filelist.length - b.filelist.length
          : b.filelist.length - a.filelist.length;
      } else if (sortConfig.key === "date") {
        const dateA = `${a.date} ${a.time}`;
        const dateB = `${b.date} ${b.time}`;
        return sortConfig.direction === "asc"
          ? dateA.localeCompare(dateB, "fa", { numeric: true })
          : dateB.localeCompare(dateA, "fa", { numeric: true });
      } else {
        return sortConfig.direction === "asc"
          ? a[sortConfig.key].localeCompare(b[sortConfig.key])
          : b[sortConfig.key].localeCompare(a[sortConfig.key]);
      }
    }
    return 0;
  });
  const filteredTransactions = sortedTransactions.filter((transaction) => {
    const isStatusMatch =
      statusFilter === "همه" || transaction.status === statusFilter;
    const isUsernameMatch = transaction.username
      .toLowerCase()
      .includes(searchQuery.toLowerCase());

    return isStatusMatch && isUsernameMatch;
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter, searchQuery]);

  const reverseMapStatus = Object.fromEntries(
    Object.entries(mapStatus).map(([key, value]) => [value, key]),
  );
  const handleStatusChange = async (username, newStatus) => {
    const statusKey = reverseMapStatus[newStatus];
    if (!statusKey || statusKey == "empty") return;

    setIsStatusLoading(true);

    try {
      const res = await changeStatus({
        accessToken,
        username,
        status: { status: statusKey },
      });

      if (res?.ok) {
        toast.success("وضعیت با موفقیت تغییر کرد");

        setTransactions((prev) =>
          prev.map((item) =>
            item.username === username ? { ...item, status: newStatus } : item,
          ),
        );

        setOriginalTransactions((prev) =>
          prev.map((item) =>
            item.username === username ? { ...item, status: newStatus } : item,
          ),
        );
      }
    } catch (error) {
      console.error("خطا در تغییر وضعیت:", error);
      toast.error("خطا در تغییر وضعیت، لطفاً دوباره تلاش کنید.");
    } finally {
      setIsStatusLoading(false);
    }
  };

  const totalPages = Math.ceil(
    filteredTransactions.length / rowsPerPage
  );
  const paginatedTransactions = filteredTransactions.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage,
  );
  const handleDateFilter = (fromDate = null, toDate = null) => {
    if (!fromDate && !toDate) {
      setTransactions(originalTransactions);
      return;
    }

    const from = moment(
      convertPersianToLatinNumbers(
        `${fromDate.year}/${fromDate.month}/${fromDate.day}`,
      ),
      "jYYYY/jM/jD",
    );
    const to = moment(
      convertPersianToLatinNumbers(
        `${toDate.year}/${toDate.month}/${toDate.day}`,
      ),
      "jYYYY/jM/jD",
    );

    setTransactions(
      originalTransactions.filter((transaction) => {
        const transactionDate = moment(
          convertPersianToLatinNumbers(transaction.date),
          "jYYYY/jMM/jDD",
        );
        return transactionDate.isBetween(from, to, "day", "[]");
      }),
    );
    setCurrentPage(1);
  };

  const convertPersianToLatinNumbers = (str) => {
    const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    const latinNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    return str
      .split("")
      .map((char) => {
        const index = persianNumbers.indexOf(char);
        return index !== -1 ? latinNumbers[index] : char;
      })
      .join("");
  };
  useEffect(() => {
    const counts = transactions.reduce(
      (acc, transaction) => {
        acc[transaction.status] =
          (acc[transaction.status] || 0) + 1;

        return acc;
      },
      {}
    );

    if (onStatusCountsChange) {
      onStatusCountsChange(counts);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactions]);
  const openCountModal = (row, type) => {
    const config = {
      knowledge: {
        title: "فایل‌های پایگاه دانش",
        count: row.knowledgeFileCount || 0,
        files: row.knowledgeFiles || [],
      },

      structured: {
        title: "فایل‌های ساختاریافته",
        count: row.structuredFileCount || 0,
        files: [],
      },

      chunk: {
        title: "چانک‌ها",
        count: row.chunkCount || 0,
        files: [],
      },
    };

    setCountModal({
      isOpen: true,
      type,
      title: config[type].title,
      count: config[type].count,
      files: config[type].files,
      data: row,
    });
  };
  const closeCountModal = () => {
    setCountModal({
      isOpen: false,
      type: null,
      title: "",
      count: 0,
      files: [],
      data: null,
    });
  };
  return (
    <div className="col-span-12 xl:col-span-6 xl:p-6 min-h-screen rtl shadow-sm">
      <div className="flex flex-wrap justify-start items-center gap-4 w-full max-w-[850px] m-auto mt-5 mb-4">
        <div className="flex items-center space-x-1  w-full">
          <label className="text-gray-700 whitespace-nowrap">جستجو:</label>
          <input
            type="text"
            placeholder="جستجو بر اساس نام بات"
            className="flex-grow py-2 border rounded px-3 w-full"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <div className="flex items-center space-x-2 w-[190px] py-2 ">
          <label className="whitespace-nowrap">فیلتر وضعیت:</label>
          <select
            className={`py-2 border rounded px-2 w-full ${statusFilter === "" ? "text-gray-400" : "text-black"
              }`}
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="" hidden>
              جستجو بر اساس وضعیت...
            </option>
            <option value="همه">همه</option>
            {statuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>
        <DateFilter onFilter={handleDateFilter} />
      </div>
      <table className=" border-none shadow-md mt-1 m-auto rtl w-full max-w-[850px] ">
        <thead className="bg-gray-100 text-gray-700 text-center rounded-xl ">
          <tr>
            <th className="p-3 w-1/6">لوگو</th>
            <th className="p-3 w-1/5">نام</th>
            <th className="p-3 w-1/5">طرح خریداری شده</th>
            <th
              className="p-3 cursor-pointer w-1/5"
              onClick={() => handleSort("date")}
            >
              تاریخ ثبت{" "}
              {sortConfig.key === "date" ? (
                sortConfig.direction === "asc" ? (
                  <FaSortUp />
                ) : (
                  <FaSortDown />
                )
              ) : (
                <FaSort />
              )}
            </th>
            <th
              className="p-1 w-1/6"
              colSpan={3}
            >
              تعداد فایل{" "}
            </th>
            <th className="p-3 w-2/5">وضعیت</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-300">
          {paginatedTransactions.map((row, index) => (
            <tr key={index} className="hover:bg-gray-100 transition">
              <td className="p-1 text-center">
                <img
                  src={row.logo ? `${BASE_URL}${row.logo}` : "/defaultLogo.png"}
                  alt="لوگو"
                  className="w-10 h-10 rounded-full border m-auto"
                />
              </td>
              <td
                className="p-3 text-center cursor-pointer"
                onClick={() => openUsernameModal(row)}
              >
                {row.username}
              </td>
              <td
                onClick={() => openPlanModal(row)}
                className="p-3 text-center cursor-pointer"
              >
                {row.planSummary.planName}
              </td>
              <td className="p-3 text-center">
                {row.date}
                <br />
                {row.time}
              </td>
              <td className="text-center">
                <button
                  onClick={() => openCountModal(row, "knowledge")}
                  className="font-bold text-gray-700 hover:text-blue-500 transition"
                >
                  {row.knowledgeFileCount || 0}
                </button>
              </td>

              <td className="text-center">
                <button
                  onClick={() => openCountModal(row, "structured")}
                  className="font-bold text-gray-700 hover:text-blue-500 transition"
                >
                  {row.structuredFileCount || 0}
                </button>
              </td>

              <td className="text-center">
                <button
                  onClick={() => openCountModal(row, "chunk")}
                  className="font-bold text-gray-700 hover:text-blue-500 transition"
                >
                  {row.chunkCount || 0}
                </button>
              </td>

              <td className="p-3 text-center">
                <Menu
                  as="div"
                  className="relative inline-block text-right group "
                >
                  <MenuButton
                    className={`w-[80px] rounded-md text-white text-sm transition-all duration-200 focus:outline-none 
                                    ${row.status === "تایید شده"
                        ? "bg-green-500 hover:bg-green-600  py-2"
                        : row.status === "عدم تایید"
                          ? "bg-red-500 hover:bg-red-600  py-2"
                          : row.status === "در انتظار"
                            ? "bg-gray-400 hover:bg-gray-600  py-2"
                            : "bg-[#FFC505] hover:bg-[#ff9305de]  py-2"
                      }`}
                  >
                    {row.status}
                  </MenuButton>
                  <MenuItems className="absolute left-3 min-w-max mt-2 w-40 bg-white shadow-lg border rounded-md z-50 focus:outline-none">
                    {statusModal.map((status) => (
                      <MenuItem
                        key={status}
                        as="button"
                        className="block w-full text-right px-4 py-2 transition active:bg-gray-200"
                        onClick={() =>
                          handleStatusChange(row.username, status)
                        }
                      >
                        {status}
                      </MenuItem>
                    ))}
                  </MenuItems>
                </Menu>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex justify-between items-center mt-6 w-full max-w-[850px] m-auto">
        <div className="flex items-center justify-between space-x-2 ">
          <label className="whitespace-nowrap text-gray-700">نمایش:</label>
          <select
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            className="py-2 border rounded-lg px-4 text-gray-700 hover:ring-2 hover:ring-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 w-16"
          >
            {[5, 10, 15].map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
        </div>

        <div className="text-center text-sm text-gray-600 ">
          نمایش {paginatedTransactions.length} از {filteredTransactions.length}{" "}
          (کل: {originalTransactions.length})
        </div>

        <div className="flex items-center space-x-3 mr-2">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
            className="p-2 border rounded-lg bg-gray-200 hover:bg-gray-300 disabled:bg-gray-200 transition duration-200"
          >
            قبلی
          </button>
          <span className="text-gray-700 px-2 text-center">
            {" "}
            {currentPage}{" "}
          </span>
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
            className="p-2 border rounded-lg bg-gray-200 hover:bg-gray-300 disabled:bg-gray-200 transition duration-200"
          >
            بعدی
          </button>
        </div>
      </div>
      <AdminInfoModal
        isOpen={isUsernameModalOpen}
        closeModal={closeUsernameModal}
        modalData={usernameModalData}
      />
      <AdminPlanModal
        isOpen={isPlanModalOpen}
        closeModal={closePlanModal}
        modalData={planModalData}
      />

      <AdminModalFileUpload
        isOpen={isModalOpen}
        closeModal={closeModal}
        modalData={modalData}
      />
      <AdminCountModal
        isOpen={countModal.isOpen}
        closeModal={closeCountModal}
        modalData={countModal}
      />
      {isStatusLoading && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl p-6 flex flex-col items-center gap-3">
            <div className="w-8 h-8 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin" />
            <span>در حال تغییر وضعیت...</span>
          </div>
        </div>
      )}
    </div>
  );
}
